/**
 * Логгер приложения — единственное место, где разрешено обращаться к console
 * (конвенции: «console.* — только логгер из shared/lib»).
 * В контекст пишется requestId/код ошибки, персональные данные сюда не передаются.
 */
export type LogContext = Readonly<Record<string, unknown>>;

const isDev = import.meta.env.DEV;

function format(message: string, context?: LogContext): unknown[] {
  return context ? [`[admin] ${message}`, context] : [`[admin] ${message}`];
}

export const logger = {
  error(message: string, context?: LogContext): void {
    console.error(...format(message, context));
  },
  warn(message: string, context?: LogContext): void {
    console.warn(...format(message, context));
  },
  /** Отладочные сообщения — только в dev-сборке. */
  debug(message: string, context?: LogContext): void {
    if (isDev && import.meta.env.MODE !== 'test') {
      // biome-ignore lint/suspicious/noConsole: логгер — единственная санкционированная обёртка над console
      console.info(...format(message, context));
    }
  },
};
